import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
    HttpResponse
} from '@angular/common/http';
import { Observable, ReplaySubject } from "rxjs";
import { catchError, tap } from 'rxjs/operators';

import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { JWT_RESPONSE_HEADER } from 'src/app/seguridad/seguridad/constantes';

@Injectable()
export class NoAuthorizationInterceptor implements HttpInterceptor {

    constructor(private messageService: MessageService, private route: Router) {

    }

    dataStream: ReplaySubject<any> = new ReplaySubject<any>();

    dataStream$(): Observable<any> {
        this.dataStream = new ReplaySubject<any>();
        return this.dataStream.asObservable();
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let accessToken = sessionStorage.getItem(JWT_RESPONSE_HEADER);

        if (accessToken) {

            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${accessToken}`,
                }
            });
        }

        return next.handle(request)
            .pipe(
                tap(event => {
                    if (event instanceof HttpResponse) {
                        // console.log(new HttpResponse(event));
                    }
                }, error => {
                    if (error.status === 0) {
                        this.mostrarMensajesError({ errors: [{ mensaje: 'Espere un momento mientras regresa la conexión' }] });
                    }
                    if (error.status === 401) { //token
                       // this.route.navigate([""]);
                       this.mostrarMensajesError(error);
                    }
                    if (error.status === undefined) { //token
                       // this.route.navigate([""]);
                       this.mostrarMensajesError(error);
                    }
                    if (error.status === 400) {
                        this.mostrarMensajesError(error);
                    }
                    if (error.status === 409) {
                        this.mostrarMensajesError(error);
                    }
                    else if (error.status === 606) {
                        // errores de UException son mostrados al usuario
                        this.dataStream.next(error);
                    }
                    else if (error.status === 500) { //caida
                        //maneja el error mandando al login
                        this.route.navigate([""]);
                        sessionStorage.removeItem('access_token');
                    }
                })
            )
    }

    mostrarMensajesError(errores: any): void {
        if (errores._body !== undefined) {
            const err = JSON.parse(errores._body);
            if (err.message != null) {
                errores.message = err.message;
            }
        }

        if (errores.errors !== undefined && errores.errors !== null) {
            errores.errors.forEach(
                errr => {
                    this.mostrarMensaje(errr.mensaje, 'error');
                }
            );
        }

        if (Array.isArray(errores.error)) {
            for (var _i = 0; _i < errores.error.length; _i++) {
                var item = errores.error[_i];
                console.log(item);
                this.mostrarMensaje(item.mensaje, 'error');
            }

        } else if (errores.message !== undefined && errores.message !== null) {
            this.mostrarMensaje(errores.message, 'error');
        }
    }

    mostrarMensaje(mensaje: string, tipo: string, callBack?: () => void): void {
        this.messageService.add({ severity: 'error', summary: 'Mensaje', detail: mensaje });
        if (callBack) {
            callBack();
        }
    }
}
